import DataLoadingMini from "../../Suspense/Loadings/DataLoadingMini/DataLoadingMini";
import { Link } from "react-router-dom";
import React from "react";
import { motion } from "framer-motion";

const SearchItem = ({
  product,
  getTextDirection,
  highlightMatchs,
  searchTerm,
  index,
  sliceWords,
  encodeId,
  loading,
  setIsResultsVisible
}) => {
  return (
    <div key={index} className="flex items-center justify-center gap-2 w-full bg-stone-300 
    hover:bg-[#E1D7B7]">
      <Link
        to={`/categories/${product.categories[0]}/${encodeId(
          product.productId
        )}`}
        className="flex w-full"
      >
        <motion.div
          dir="rtl"
          onClick={() => setIsResultsVisible(false)}
          className="flex items-start justify-start gap-2 border-b-2 rounde pl-2 shadow-lg 
                       border-black overflow-hidden relative w-full"
        >
          <div
            className="flex items-center justify-center w-[5rem] h-[7rem]
                        overflow-hidden border-l-2 border-black"
          >
            {loading ? (
              <DataLoadingMini color="bg-yellow-500" />
            ) : (
              <img
                src={product.productImg}
                alt={product.productName}
                className="w-full h-full object-contain"
              />
            )}
          </div>
          <div
            className="flex flex-col items-center justify-center h-[7rem] 
                      overflow-y-scroll gap-2 no-scrollbar relative"
          >
            <div
              dir={getTextDirection(product.productName)}
              className="w-[8rem] break-words text-center font-bold relative group"
            >
              {highlightMatchs(sliceWords(product.productName), searchTerm)}
              <div
                className="absolute w-[9rem]  transform  -translate-y-[3.1rem]
                  mb-2 hidden group-hover:block bg-black text-white text-sm rounded py-1 
                  px-2 break-words z-10 right-0 translate-x-1"
              >
                {product.productName}
              </div>
            </div>
            <div
              dir={getTextDirection(product.prodcutName)}
              className="w-[9rem] break-words py-1 text-center text-sm"
            >
              {highlightMatchs(
                product.categories[0].replace(/-/g, " "),
                searchTerm
              )}
            </div>
          </div>
        </motion.div>
      </Link>
    </div>
  );
};

export default SearchItem;
